/**
 * Client Stores Config Repository (read-only)
 */

import { apiClient } from '../client'
import type { PaginatedResponse } from './role.repository'

export interface ClientStoresConfig {
  id: number
  tenant_id: number
  client_id: number
  store_id: number
  depo?: string | null
  delivery_mode?: string | null
  warehouse?: string | null
  stp_code?: string | null
  store_group?: string | null
  created_by?: number | null
  updated_by?: number | null
  created_at: string
  updated_at: string
  client_name?: string | null
  client_name_ar?: string | null
  store_name?: string | null
  store_name_ar?: string | null
  store_code?: string | null
  region_name?: string | null
  city_name?: string | null
  area_name?: string | null
  store_format_name?: string | null
  store_class_name?: string | null
  channel_name?: string | null
  chain_name?: string | null
  sub_channel_name?: string | null
  trade_type_name?: string | null
  created_by_name?: string | null
  updated_by_name?: string | null
}

export type ClientStoresFilters = {
  search?: string
  client_id?: number
  store_id?: number
}

class ClientStoresRepository {
  async getAll(
    page: number = 1,
    limit: number = 10,
    filters?: ClientStoresFilters,
  ): Promise<PaginatedResponse<ClientStoresConfig>> {
    const params = new URLSearchParams({
      page: String(page),
      limit: String(limit),
    })

    if (filters?.search?.trim()) params.append('search', filters.search.trim())
    if (filters?.client_id != null) params.append('client_id', String(filters.client_id))
    if (filters?.store_id != null) params.append('store_id', String(filters.store_id))

    return apiClient.get<PaginatedResponse<ClientStoresConfig>>(`/client-stores?${params.toString()}`)
  }
}

export const clientStoresRepository = new ClientStoresRepository()
